import { gql } from '@apollo/client'
import { BodyText, Heading } from '@farol-ds/react'
import { Price } from '@jusbrasil-web/shared-price'
import classNames from 'classnames'

import { BenefitsList } from '../benefits-list'
import { CheckoutButton } from '../checkout-button'
import { OneClickButton } from '../one-click-button'
import {
  FirstBuyOrFiveMonitorCreditsContent_OfferLockDataFragment,
  FirstBuyOrFiveMonitorCreditsContent_ViewerFragment,
} from './__generated__/first-buy-or-five-monitor-credits-content.graphql'
import styles from './first-buy-or-five-monitor-credits-content.module.scss'

type FirstBuyOrFiveMonitorCreditsContentProps = {
  offerLockData: FirstBuyOrFiveMonitorCreditsContent_OfferLockDataFragment
  viewer: FirstBuyOrFiveMonitorCreditsContent_ViewerFragment
}

export function FirstBuyOrFiveMonitorCreditsContent({
  offerLockData,
  viewer,
}: FirstBuyOrFiveMonitorCreditsContentProps) {
  const { header, body } = offerLockData
  const { title, subtitle } = header
  const {
    cards: [card],
  } = body || {}
  const isWinback = !!card.creditCard?.brandName

  const cardClasses = classNames(
    styles.card,
    {
      [styles['card--winback']]: isWinback,
    },
    styles.wrapperPrice,
    {
      [styles['wrapperPrice--firstBuy']]: !isWinback,
    }
  )

  return (
    <>
      <div className={styles.header}>
        <Heading size="lg" className={styles.title}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>
        <BodyText size="md">
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </BodyText>
      </div>
      <div className={cardClasses}>
        <div className={cardClasses}>
          <CheckoutButton offerLockCard={card} kind="primary" viewer={viewer} />
          <Price align="center" size="lg">
            <Price.Value className={styles.price}>
              {card.offer.priceText}
              {card.offer.frequency && (
                <Price.ValueFrequency>{card.offer.frequency}</Price.ValueFrequency>
              )}
            </Price.Value>
          </Price>

          <OneClickButton offerLockCard={card} viewer={viewer} kind="primary" />
        </div>
        <BenefitsList offerLockCard={card} />
      </div>
    </>
  )
}

FirstBuyOrFiveMonitorCreditsContent.fragments = {
  offerLockData: gql`
    fragment FirstBuyOrFiveMonitorCreditsContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          offer {
            priceTitle
            priceText
            frequency
          }
          ...OneClickButton_offerLockCard
          ...CheckoutButton_offerLockCard
          ...BenefitsList_offerLockCard
        }
      }
    }
    ${OneClickButton.fragments.offerLockCard}
    ${CheckoutButton.fragments.offerLockCard}
    ${BenefitsList.fragments.offerLockCard}
  `,
  viewer: gql`
    fragment FirstBuyOrFiveMonitorCreditsContent_viewer on Profile {
      ...OneClickButton_viewer
      ...CheckoutButton_viewer
    }
    ${OneClickButton.fragments.viewer}
    ${CheckoutButton.fragments.viewer}
  `,
}
